export const RecentProjectData = [
  {
    title: 'How to Develop Mobile Application for your Business?',
    detail:
      'In this article, I’ll help out you with how to get a Mobile application for your business',
    image: 'https://miro.medium.com/max/300/1*9Lu87rPNnTD_gOotA0Hi9Q.jpeg',
    link: 'https://medium.com/@m-rashid/how-to-develop-mobile-application-for-your-business-4b6923f45d29',
  },
  {
    title: 'Host Django Application using gunicorn & nginx in Production on AWS Ubuntu server',
    detail:
      ' we will see how to use nginx with gunicorn to serve django applications in production.',
    image: 'https://miro.medium.com/fit/c/224/224/0*bprZpuVvyjukYzJI',
    link: 'https://medium.com/@m-rashid/host-django-application-using-gunicorn-nginx-in-production-on-aws-ubuntu-server-4b1551e13c66',
  },
  {
    title: 'How to become a Web 3.0 Developer in 2022',
    detail:
      'Web 3.0 is known as the Third Generation of internet services for websites and applications.',
    image: 'https://miro.medium.com/max/300/1*FrPmMFi6_xOS54DVswXbDQ.jpeg',
    link: 'https://medium.com/@m-rashid/how-to-become-a-web-3-0-developer-in-2022-e97b346e5919',
  },

  {
    title: 'What is Metaverse? A complete Guide',
    detail:
      'The Metaverse represents a noticeably interactive three-dimensional digital world.',
    image: 'https://miro.medium.com/max/300/1*DM9RL1ToMk_r88pwl2nBoA.webp',
    link: 'https://medium.com/@m-rashid/what-is-metaverse-a-complete-guide-b63b0b700a07',
  },

  {
    title: 'Jenkins CI/CD Pipeline setup on EC2 With Git and EKS',
    detail:
      'A walkthrough of the CI/CD Pipeline setup on EC2 with git and EKS',
    image: 'https://miro.medium.com/max/304/1*dEq7yBUVGTEvkzA119UXHQ.png',
    link: 'https://medium.com/@m-rashid/jenkins-ci-cd-pipeline-setup-on-ec2-with-git-and-eks-f311595a94ef',
  }, {
    title: 'What is DeFi? A Complete Guide',
    detail:
'Decentralized Finance offers financial instruments without depending on go-betweens like brokerages, trades, or banks by utilizing smart contracts on a blockchain.',
    image: 'https://miro.medium.com/max/304/1*nj0Nvs64JB6uwwX5FVU4fw.webp',
    link: 'https://m-rashid.medium.com/what-is-defi-6be69e64ca90',
  },
]
